import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-conditions',
  standalone: false,
  templateUrl: './terms-conditions.component.html'
})
export class TermsConditionsComponent {

}
